import React from 'react';

/** Lazy ClientComputedRecommendedTrainingCourses (not wrapped in a suspense to use the parent widget loading fallback) */
export const ClientComputedRecommendedTrainingCourses = React.lazy(
    () =>
        import(
            /* webpackChunkName: 'widget-recommended-training-courses' */
            './ClientComputedRecommendedTrainingCourses'
        ),
);
